;(function () {
  'use strict'

  angular.module('admin.affiliates.service', []).factory('AffiliatesService', AffiliatesService)

  /** @ngInject */
  function AffiliatesService($http, $q, API) {
    function listPending(start, limit) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/affiliates/pending?start=' + start + '&limit=' + limit)
        .success(defered.resolve)

      return defered.promise
    }

    function listApproved(start, limit) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/affiliates/approved?start=' + start + '&limit=' + limit)
        .success(defered.resolve)

      return defered.promise
    }

    function listRejected(start, limit) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/affiliates/rejected?start=' + start + '&limit=' + limit)
        .success(defered.resolve)

      return defered.promise
    }

    function search(text, status, type) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/affiliates/search?t=' + text + '&st=' + status + '&k=' + type)
        .success(defered.resolve)

      return defered.promise
    }

    function get(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/affiliates/' + id).success(defered.resolve)

      return defered.promise
    }

    function save(model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/affiliates', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function update(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/affiliates/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/affiliates/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function approved(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/affiliates/' + id + '/approve')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function rejected(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/affiliates/' + id + '/reject')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listSocialProfile() {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/affiliate_social_profiles').success(defered.resolve)

      return defered.promise
    }

    function getSocialProfile(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/affiliate_social_profiles/' + id).success(defered.resolve)

      return defered.promise
    }

    function saveSocialProfile(model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/affiliate_social_profiles', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function updateSocialProfile(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/affiliate_social_profiles/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeSocialProfile(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/affiliate_social_profiles/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function saveFavorite(parentId, id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/affiliates/' + parentId + '/channels/' + id)
        .success(defered.resolve)

      return defered.promise
    }

    function removeFavorite(parentId, id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/affiliates/' + parentId + '/channels/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    return {
      listPending: listPending,
      listApproved: listApproved,
      listRejected: listRejected,
      get: get,
      save: save,
      update: update,
      remove: remove,
      approved: approved,
      rejected: rejected,
      listSocialProfile: listSocialProfile,
      getSocialProfile: getSocialProfile,
      saveSocialProfile: saveSocialProfile,
      updateSocialProfile: updateSocialProfile,
      removeSocialProfile: removeSocialProfile,
      saveFavorite: saveFavorite,
      removeFavorite: removeFavorite,
    }
  }
})()
